module.exports = __webpack_public_path__ + "img/cn.9caece66.svg";